import { IMspStatusData } from '../interfaces/msp-statuses-map';
import { HubMSPSortColumn, hubMSPSortColumns } from '../models/hub-msp-sort-column';

/** Returns the given [value] if it is a HubOrdersSortColumn, else the [defaultValue] is returned */
export const valueAsOrdersSortColumn = (
  value: string | undefined,
  defaultValue: HubMSPSortColumn = 'dateEntered',
): HubMSPSortColumn => {
  if (value === undefined) {
    return defaultValue;
  }

  const isSortColumn = hubMSPSortColumns.includes(value as HubMSPSortColumn);
  return isSortColumn ? (value as HubMSPSortColumn) : defaultValue;
};

// TODO: Determine what this is used for
const DEFAULT_STATUS_DATA: IMspStatusData = {
  cwStatus: '',
  hubStatus: '',
  highlightStage: null,
  colorProfile: {
    foregroundColor: 'var(--background-grey-2)',
    backgroundColor: 'var(--background-grey-2)',
  },
  slaGroup: null,
  isClosed: false,
  boardName: '',
  isCloseDefault: false,
};

/**
 * Get the MSP status data for a given status name and board name.
 * If the status is not found, return the default status data.
 */
export const getStatusData = (
  statusName: string | undefined,
  boardName: string | undefined,
  data: IMspStatusData[] | undefined,
): IMspStatusData => {
  // Handle undefined inputs
  if (!statusName || !boardName || !data) {
    return {
      ...DEFAULT_STATUS_DATA,
      cwStatus: statusName ?? '',
      hubStatus: statusName ?? '',
      boardName: boardName ?? '',
    };
  }

  // Normalize strings for comparison
  const normalizedStatus = statusName.trim();
  const normalizedBoard = boardName.trim();

  // Find matching status
  return (
    data.find(
      (status) => status.boardName?.trim() === normalizedBoard && status.cwStatus?.trim() === normalizedStatus,
    ) ?? {
      ...DEFAULT_STATUS_DATA,
      cwStatus: normalizedStatus,
      hubStatus: normalizedStatus,
      boardName: normalizedBoard,
    }
  );
};
